import { Stack, TextInput, StackItem } from '@optimus-web/core';
import { DateTimeService, lt, useDateTimeLocalizationInfo, useLocalizeText, useTimezone } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    OnboardingStatus,
    OnboardingStatusGetParameters,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { WithEnterpriseId } from '@mews-commander/types';

export const GoLiveLastChange = ({ enterpriseId }: WithEnterpriseId) => {
    const localizeText = useLocalizeText();
    const timezone = useTimezone();
    const dateTimeLocalizationInfo = useDateTimeLocalizationInfo();
    const { data: lastLog } = useGetOnboardingStatusLastLog({ enterpriseId, extent: { actionLogs: true } });

    if (!lastLog) return null;

    const { user, changeUtc, newValue } = lastLog;

    const textKey = newValue.includes(OnboardingStatus.GoLive)
        ? TextKey.OnboardingGoLiveChangeAllowed
        : TextKey.OnboardingGoLiveChangePrevented;

    const statusText = localizeText({
        textKey,
        substitutes: { User: user },
    });

    const formattedTime = DateTimeService.toString(
        DateTimeService.fromUtcString(changeUtc, timezone),
        dateTimeLocalizationInfo
    );

    const value = `${statusText} - ${formattedTime}`;

    return (
        <Stack>
            <StackItem grow>
                <TextInput
                    name="Last change"
                    label={lt('OnboardingGoLiveLastChange')}
                    value={value}
                    size="large"
                    readOnly
                />
            </StackItem>
        </Stack>
    );
};

export const useGetOnboardingStatusLastLog = (params: OnboardingStatusGetParameters) =>
    useRepositorySuspenseQuery('enterprises', 'getOnboardingStatus', params, {
        select: (data) => data.onboardingStatusActionLogs?.at(-1),
    });
